import { render, staticRenderFns } from "./picture-book.vue?vue&type=template&id=7d9970cc&"
import script from "./picture-book.vue?vue&type=script&lang=ts&"
export * from "./picture-book.vue?vue&type=script&lang=ts&"
import style0 from "./picture-book.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports